import { getMicrosoftSsoLoginUrl, login, useAppDispatch, useAppSelector } from "@template/state";
import { DEMO_CREDENTIALS_BANNER_TEXT, ROUTES } from "@template/types";
import {
  AuthBrandPanel,
  AuthFormCard,
  AuthShell,
  Button,
  Input,
  PasswordInput,
  showToast,
} from "@template/ui";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useState, type FormEvent } from "react";
import { Link as RouterLink } from "react-router-dom";
import { getRuntimeConfig } from "../../config/runtime-config";
import { getErrorMessage } from "../../lib/error-message";

const config = getRuntimeConfig();

export function LoginPage() {
  const dispatch = useAppDispatch();
  const status = useAppSelector((state) => state.auth.status);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    try {
      await dispatch(login({ email, password })).unwrap();
    } catch (err) {
      showToast(getErrorMessage(err, "Login failed"), "error");
    }
  }

  function handleMicrosoftLogin() {
    window.location.href = getMicrosoftSsoLoginUrl(config.apiBaseUrl);
  }

  return (
    <AuthShell
      brandPanel={
        <AuthBrandPanel appName={config.appName} tagline="Sign in to access the finance portal." />
      }
    >
      <AuthFormCard
        title="Sign in"
        subtitle="Enter your credentials to continue"
        footer={
          <Typography variant="body2" color="text.secondary" align="center">
            <Link component={RouterLink} to={ROUTES.forgotPassword}>
              Forgot your password?
            </Link>
          </Typography>
        }
      >
        <Stack spacing={2} component="form" onSubmit={handleSubmit}>
          {config.showDemoCredentials ? (
            <Alert severity="info">{DEMO_CREDENTIALS_BANNER_TEXT}</Alert>
          ) : null}
          <Input
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
          <PasswordInput
            label="Password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          <Button type="submit" variant="contained" size="large" loading={status === "loading"}>
            Sign in
          </Button>
          <Divider>or</Divider>
          <Button variant="outlined" size="large" onClick={handleMicrosoftLogin}>
            Login with Microsoft
          </Button>
        </Stack>
      </AuthFormCard>
    </AuthShell>
  );
}
